import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CartBtn from "@tw/shared-ui-components/lib/components/addToCartButton/cartBtn";
import Breakpoint from "@tw/style-guide/lib/components/utilities/breakpoint";
import styles from "./promotionBasic.scss";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import HeroBanner from "../../../../common/components/heroBanner/heroBanner";
import telescope from "../assests/telescope.png";
import PromotionCardList from "../promotionCardList/promotionCardList";
import TopBanner from "../../../../common/components/topBanner/topBanner";
import BreadCrumbs from "../../../../common/components/breadCrumbs/breadCrumbs";
import { resetPromotionDetails } from "../../../common/redux/reducers";
import EmptyListTemplate from "../../../../common/components/emptyListTemplate/emptyListTemplate";
import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { DEFAULT_BUNDLE } from "../../../../common/constant";
import { batchAddToCart } from "../../../../common/utils/apis";
import {
  trackAddToCart,
  ttqTrackEventBuryingPoint,
  trackProductViewList,
  PAGES,
} from "@tw/shared-ui-components/lib/utils/analytics";
import {
  getLoggedInUserInfo,
  getPageDetails,
} from "../../../../common/utils/helper";
import NoTranslate from "../../../../common/components/notranslate/noTranslate";
import SEOHead from "../../../../common/components/seoHead/seoHead";

function PromotionBasic({ Link, NextHead }) {
  const [breakpoint, setBreakpoint] = useState("xs");

  const intlNumberFormatter = new Intl.NumberFormat("en-US");
  const aboUserRoleIdentifier = "ABO";
  const loggedInUserRole = getLoggedInUserInfo().role;
  const dispatch = useDispatch();
  // Getting total Price / PV / BV values
  const selectedPromotionDetails = useSelector(
    (state) => state.plpState && state.plpState.selectedPromotionDetails
  );

  // Getting Promotion Products
  const promotionProducts = useSelector(
    (state) => state.plpState && state.plpState.promotionProducts
  );

  // Getting Promotion details from Contentstack
  const promotionDetails = useSelector(
    (state) => state.plpState && state.plpState.promotionDetails
  );

  const promotionTitle = useSelector((state) => state?.plpState?.title);
  const participation = useSelector((state) => state?.plpState?.participation);

  const pageDetails = getPageDetails(null, PAGES.promotion);

  // batch add to cart
  const onAddToCart = async () => {
    const products = promotionProducts?.productsData
      ?.map(
        (product) =>
          product.quantity > 0 && {
            itemCode: product.itemCode,
            quantity: product.quantity,
          }
      )
      .filter(Boolean);

    try {
      const res = await batchAddToCart(products);
      if (res.status === 200) {
        /*  ===============================================  TEP-15578 ============================================= */
        ttqTrackEventBuryingPoint('addToCart', products)
        /*  ===============================================  TEP-15578 ============================================= */
        // tealium analytics
        trackAddToCart(
          promotionProducts?.productsData,
          products?.map((product) => product?.quantity),
          pageDetails
        );
        dispatch(resetPromotionDetails());

        dispatch(
          updateCartDetails({
            id: DEFAULT_BUNDLE,
            totalQuantity: res?.data?.data?.totalQuantity,
            products: promotionProducts?.productsData
              ?.map(
                (product) =>
                  product?.quantity > 0 && {
                    product,
                    quantity: product?.quantity,
                  }
              )
              .filter(Boolean),
          }, 3)
        );
      } else {
        toastMsg(res?.response?.data?.message);
      }

    } catch (err) {
      toastMsg(err?.response?.data?.message || err?.message);
      console.log(err);
    }
  };
  const detailsUrl = promotionDetails?.detailsPageUrl
    ? `/page?url=${promotionDetails?.detailsPageUrl}`
    : "";

  const isValidForPromotion = selectedPromotionDetails?.totalQuantity === 0;

  // tealium analytics
  useEffect(() => {
    // TEAL-2330
    let timer;
    if (typeof window !== 'undefined' && typeof window !== undefined) {
      let times = 0;
      timer = setInterval(async () => {
        if (window?.utag && promotionDetails) {
          await clearInterval(timer)
          await trackProductViewList({
            products: promotionProducts?.productsData?.map((product) => ({
              ...product,
              promotionCode: promotionDetails?.promotionCode,
            })),
            page: pageDetails,
          });
        } else {
          if (times >= 20) {
            await clearInterval(timer)
          }
          times++
        }
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [promotionDetails]);

  const getColumnCount = () => {
    if (breakpoint === "lg" || breakpoint == "sm") return 4;
    return 2;
  };

  return (
    <>
      <SEOHead NextHead={NextHead} seoConfig={{ pageTitle: promotionTitle }} />
      <TopBanner heading={promotionTitle} displayProductCount={false} />
      {participation ? (
        <div>
          <div className={styles["breadcrumbs-wrapper"]}>
            <BreadCrumbs
              list={[
                { categoryName: "首頁", link: "/" },
                { categoryName: "特惠活動", link: "/promotions/list" },
              ]}
              lastChildName={promotionTitle}
              Link={Link}
            />
          </div>
          <div className={styles["plp-hero-banner"]}>
            <HeroBanner banners={promotionDetails?.heroBanners} />
          </div>
          <div className={styles["promotion-details-container"]}>
            <a href={detailsUrl} target="_blank" rel="noreferrer">
              <a>
                <div className={styles["promotion-details-div"]}>
                  <img src={telescope} alt="telescope icon" />
                  <span>查看詳情</span>
                </div>
              </a>
            </a>
          </div>
          <div className={styles["promotion-card-list"]}>
            <PromotionCardList
              col={getColumnCount()}
              listDetails={promotionProducts?.productsData}
            />
          </div>
          <div className={styles["promotion-footer"]}>
            <div className={styles["promotion-footer-left"]}>
              <div className={styles["promotion-selected-details"]}>
                <span>
                  目前所選產品總數(件)：
                  {selectedPromotionDetails &&
                    selectedPromotionDetails.totalQuantity}
                </span>
              </div>
              {loggedInUserRole === aboUserRoleIdentifier && (
                <div className={styles["promotion-pv-bv"]}>
                  <span>
                    PV :
                    <p>
                      &nbsp;
                      {selectedPromotionDetails &&
                        intlNumberFormatter.format(
                          selectedPromotionDetails.totalPointVolume
                        )}
                    </p>
                  </span>
                  <span>
                    BV :
                    <p>
                      &nbsp;
                      {selectedPromotionDetails &&
                        intlNumberFormatter.format(
                          selectedPromotionDetails.totalBusinessVolume
                        )}
                    </p>
                  </span>
                </div>
              )}
            </div>

            <div className={styles["promotion-footer-right"]}>
              <div className={styles["promotion-amount-section"]}>
                <span className={styles.amount}>
                  總金額：
                  <p>
                    <NoTranslate>
                      {" "}
                      $ &nbsp;
                      {selectedPromotionDetails &&
                        intlNumberFormatter.format(
                          selectedPromotionDetails.totalPrice
                        )}
                    </NoTranslate>
                  </p>
                </span>
                <div className={styles["promotion-cart-btn"]}>
                  <CartBtn
                    cartText="加入購物車"
                    isOutOfStock={isValidForPromotion}
                    onAddToCart={onAddToCart}
                    displayCartIcon={false}
                  />
                </div>
              </div>
            </div>
          </div>
          <Breakpoint onBreakpointChange={setBreakpoint} />
        </div>
      ) : (
        <div className={styles["empty-list"]}>
          <EmptyListTemplate message="沒有促銷商品" />
        </div>
      )}
    </>
  );
}

export default PromotionBasic;
